import React from 'react';
import { motion } from 'framer-motion';
import { scenarios } from '../data/content';
export function Scenarios() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-8 sm:py-20" data-id="element-179" data-mp="3byu9vb34xifz">
      <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="2xbrcd4etb9sn">
        <h2 className="mx-auto max-w-2xl text-center font-display text-2xl font-bold leading-tight text-plum sm:text-3xl" data-id="element-181" data-mp="2xaze1lttyxyo">
          Situaciones en las que este método marca una diferencia real
        </h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-182" data-mp="2o99qir32kj66">
          {scenarios.map((scenario, index) => <motion.figure key={scenario.title} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-183" data-mp="2sa20jmjrms3i" data-mpi={index}>
              <div className="overflow-hidden rounded-2xl border border-plum/10 shadow-sm" data-id="element-184" data-mp="hjv2jh3oebyn">
                <img src={scenario.image} alt={scenario.title} className="h-44 w-full object-cover sm:h-40" loading="lazy" data-id="element-185" data-mp="1b8iwckey3enc" />
              </div>
              <figcaption className="mt-3 text-center font-sans text-sm font-bold text-plum" data-id="element-186" data-mp="1k12rvbzxx33y">
                {scenario.title}
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}